<div class="container-fluid justify-content-center d-flex flex-column pt-4 px-5">
    @if (working()) {
        <div class="d-flex justify-content-center align-items-center flex-column" style="height: calc(100vh - 56px)">
            <div class="mb-3">Récupération des enquêtes...</div>
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    }
    @if (!working() && enquetes()?.length > 0) {
        <div>
            <div class="row">
                <div class="col-12 d-flex align-items-center pb-3">
                    <h3>Liste des Enquêtes</h3>
                    <button (click)="getEnquestesCsvExport()" [disabled]="working()" class="btn btn-secondary btn-sm ms-2">Export CSV</button>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-12">
                    <div class="container-table">
                        <ag-grid-angular (rowClicked)="openViewEnqueteModal($any($event))" [columnDefs]="colDefs" [defaultColDef]="defaultColDef" [localeText]="localeFr" [rowData]="enquetes()" [scrollbarWidth]="14" [tooltipShowDelay]="500" [tooltipShowMode]="'whenTruncated'" class="ag-theme-quartz"> </ag-grid-angular>
                    </div>
                </div>
            </div>
            @if (enquetes()?.length === 0) {
                <div>
                    <p class="text fs-6 fw-bold">Aucune enquête trouvée</p>
                </div>
            }
        </div>
    }
</div>

<ng-template #viewEnqueteModal>
    <div class="modal-body d-flex w-100 justify-content-center align-items-center">
        @if (selectedEnquete()) {
            <div class="card my-5">
                @if (selectedEnquete().codeAffaire) {
                    <div class="card-header">
                        <div class="row">
                            <div class="col-11">
                                <h5 class="py-2 m-0 text-start">Affaire n°{{ selectedEnquete().codeAffaire }} - {{ selectedEnquete().nomAffaire }}</h5>
                            </div>
                            <div class="col-1 d-flex justify-content-end align-items-center">
                                <button (click)="dismissViewEnqueteModal()" [disabled]="working()" aria-label="Close" class="btn-close" type="button"></button>
                            </div>
                        </div>
                    </div>
                }
                <div class="card-body">
                    <div class="row">
                        <div class="col-6 pe-0">
                            <h5 class="card-title pt-2 text-start">Informations Enquête {{ selectedEnquete()?.id }}</h5>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-auto pe-0">
                            <h6 (click)="openUpdateStatusModal()" [ngClass]="working() ? 'subtle-waiting' : ''" class="text-start fw-normal subtle-edit-button" title="Modifier le Statut">
                                Statut:
                                {{ selectedEnquete().sat?.lancement ? selectedEnquete().sat?.lancement : "En attente de validation" }}
                            </h6>
                        </div>
                    </div>
                    @if (selectedEnquete()?.sat?.launchDate) {
                        <div class="row">
                            <div class="col-6 pe-0">
                                <h6 class="text-start fw-normal">Date de lancement : {{ selectedEnquete().sat?.launchDate ? (selectedEnquete().sat?.launchDate | formatDateFromBack) : "-" }}</h6>
                            </div>
                        </div>
                    }
                    @if (selectedEnquete()?.sat?.valideur) {
                        <div class="row">
                            <div class="col-6 pe-0">
                                <h6 class="text-start fw-normal">Modifié par {{ selectedEnquete().sat.valideur }}</h6>
                            </div>
                        </div>
                    }
                    <div class="row pt-4">
                        <div class="col-12">
                            <div class="row row-cols-4 gx-5 gy-2 ps-3">
                                <div class="col-3">
                                    <div class="row">Type</div>
                                    <div class="row">
                                        <p class="ps-0 fw-bold">
                                            {{ selectedEnquete()?.typeEnquete }}
                                        </p>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="row">Code Chantier</div>
                                    <div class="row">
                                        <p class="ps-0 fw-bold">
                                            {{ selectedEnquete().codeChantier ? selectedEnquete().codeChantier : "-" }}
                                        </p>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="row">Code Entité Principal</div>
                                    <div class="row">
                                        <p class="ps-0 fw-bold">
                                            {{ selectedEnquete().codeEntitePrincipale ? selectedEnquete().codeEntitePrincipale : "-" }}
                                        </p>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="row">Montant Tractation TCE</div>
                                    <div class="row">
                                        <p class="ps-0 fw-bold">
                                            {{ selectedEnquete().montantTractationTCE ? selectedEnquete().montantTractationTCE : "-" }}
                                        </p>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="row">Cumul Origine</div>
                                    <div class="row">
                                        <p class="ps-0 fw-bold">
                                            {{ selectedEnquete().cumulOrig ? selectedEnquete().cumulOrig : "-" }}
                                        </p>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="row">Complétion</div>
                                    <div class="row">
                                        <p class="ps-0 fw-bold">
                                            {{ buildCompletionLabel(selectedEnquete()) }}
                                        </p>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="row">Date Validation</div>
                                    <div class="row">
                                        <p class="ps-0 fw-bold">
                                            {{ selectedEnquete().sat?.dateValidation ? (selectedEnquete().sat?.dateValidation | formatDateFromBack) : "-" }}
                                        </p>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="row">Emails Relais Satisfaction</div>
                                    @if (selectedEnquete()?.relaisSAT?.length > 0) {
                                        <div class="row">
                                            @for (relai of selectedEnquete().relaisSAT; track relai) {
                                                <p class="ps-0 mb-0 fw-bold">
                                                    {{ relai ? relai : "Email inconnu" }}
                                                </p>
                                            }
                                        </div>
                                    }
                                    @if (!(selectedEnquete()?.relaisSAT?.length > 0)) {
                                        <div class="row">
                                            <p class="ps-0 fw-bold">-</p>
                                        </div>
                                    }
                                </div>
                                @if (selectedEnquete()?.typeEnquete === "GPA") {
                                    <div class="col-3">
                                        <div class="row">Gestion du SAV</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ selectedEnquete().gestionSav ? "Avec gestion du SAV dédié" : selectedEnquete().gestionSav === false ? "Sans gestion du SAV dédié" : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body pt-4">
                    <div class="row">
                        <div class="col-6 pe-0">
                            <h5 class="card-title pt-2 text-start">Intervenant MOA</h5>
                        </div>
                    </div>
                    <div class="row">
                        @if (!selectedEnquete().intervenantMOA) {
                            <div class="col-12">
                                <div class="row ps-3">Inconnu</div>
                            </div>
                        }
                        @if (selectedEnquete().intervenantMOA) {
                            <div class="col-12">
                                <div class="row row-cols-4 gx-5 gy-2 ps-3">
                                    <div class="col-3">
                                        <div class="row">Nom</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ selectedEnquete().intervenantMOA.nom ? selectedEnquete().intervenantMOA.nom : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Raison Sociale</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ selectedEnquete().intervenantMOA.raisonSociale ? selectedEnquete().intervenantMOA.raisonSociale : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Position</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ selectedEnquete().intervenantMOA.position ? selectedEnquete().intervenantMOA.position : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Mail</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ selectedEnquete().intervenantMOA.mail ? selectedEnquete().intervenantMOA.mail : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Téléphone fixe</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ selectedEnquete().intervenantMOA.telFixe ? selectedEnquete().intervenantMOA.telFixe : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Téléphone portable</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ selectedEnquete().intervenantMOA.gsm ? selectedEnquete().intervenantMOA.gsm : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div class="card-body pt-4">
                    <div class="row">
                        <div class="col-6 pe-0">
                            <h5 class="card-title pt-2 text-start">Intervenant MOE</h5>
                        </div>
                    </div>
                    <div class="row">
                        @if (!selectedEnquete().intervenantMOE) {
                            <div class="col-12">
                                <div class="row ps-3">Inconnu</div>
                            </div>
                        }
                        @if (selectedEnquete().intervenantMOE) {
                            <div class="col-12">
                                <div class="row row-cols-4 gx-5 gy-2 ps-3">
                                    <div class="col-3">
                                        <div class="row">Nom</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ selectedEnquete().intervenantMOE.nom ? selectedEnquete().intervenantMOE.nom : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Raison Sociale</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ selectedEnquete().intervenantMOE.raisonSociale ? selectedEnquete().intervenantMOE.raisonSociale : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Position</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ selectedEnquete().intervenantMOE.position ? selectedEnquete().intervenantMOE.position : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Mail</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ selectedEnquete().intervenantMOE.mail ? selectedEnquete().intervenantMOE.mail : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Téléphone fixe</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ selectedEnquete().intervenantMOE.telFixe ? selectedEnquete().intervenantMOE.telFixe : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Téléphone portable</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ selectedEnquete().intervenantMOE.gsm ? selectedEnquete().intervenantMOE.gsm : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div class="card-body pt-4">
                    <div class="row">
                        <div class="col-6 pe-0">
                            <h5 class="card-title pt-2 text-start">Intervenant Autre</h5>
                        </div>
                    </div>
                    <div class="row">
                        @if (!selectedEnquete().intervenantAUTRE) {
                            <div class="col-12">
                                <div class="row ps-3">Inconnu</div>
                            </div>
                        }
                        @if (selectedEnquete().intervenantAUTRE) {
                            <div class="col-12">
                                <div class="row row-cols-4 gx-5 gy-2 ps-3">
                                    <div class="col-3">
                                        <div class="row">Nom</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ selectedEnquete().intervenantAUTRE.nom ? selectedEnquete().intervenantAUTRE.nom : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Raison Sociale</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ selectedEnquete().intervenantAUTRE.raisonSociale ? selectedEnquete().intervenantAUTRE.raisonSociale : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Position</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ selectedEnquete().intervenantAUTRE.position ? selectedEnquete().intervenantAUTRE.position : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Mail</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ selectedEnquete().intervenantAUTRE.mail ? selectedEnquete().intervenantAUTRE.mail : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Téléphone fixe</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ selectedEnquete().intervenantAUTRE.telFixe ? selectedEnquete().intervenantAUTRE.telFixe : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Téléphone portable</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ selectedEnquete().intervenantAUTRE.gsm ? selectedEnquete().intervenantAUTRE.gsm : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div class="card-body pt-4">
                    <div class="row">
                        <div class="col-6 pe-0">
                            <h5 (click)="openCreateSentMailModal()" [ngClass]="working() ? 'subtle-waiting' : ''" class="card-title pt-2 text-start subtle-add-button" title="Ajouter un envoi de mail">&nbsp;Mails envoyés</h5>
                        </div>
                    </div>
                    <div class="row">
                        @if (!(selectedEnquete().sentEmails?.length > 0)) {
                            <div class="col-12">
                                <div class="row ps-3">Aucun mail envoyé</div>
                            </div>
                        }
                        @if (selectedEnquete().sentEmails?.length > 0) {
                            <div class="table-responsive" style="max-height: 50vh">
                                <table class="table">
                                    <caption class="visually-hidden">
                                        Mails
                                    </caption>
                                    <thead>
                                        <tr style="cursor: default">
                                            <th class="enquete-table-cell" scope="col" title="Id Enquête">Type</th>
                                            <th class="enquete-table-cell" scope="col" title="Type Enquête">Nombre</th>
                                            <th class="enquete-table-cell" scope="col" title="Code Affaire">Dernière date d'envoi</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (mail of selectedEnquete().sentEmails; track mail) {
                                            <tr>
                                                <th class="fw-normal enquete-table-cell" scope="row">
                                                    <span (click)="deleteSentMail(mail)" [ngClass]="working() ? 'subtle-waiting' : ''" class="subtle-remove-button m-0" title="Supprimer l'envoi"> &nbsp;{{ mail.typeUseCase ? getTypeUseCaseName(mail.typeUseCase) : "-" }} </span>
                                                </th>
                                                <td class="enquete-table-cell" title="{{ mail.sentCount ? mail.sentCount : '-' }}">
                                                    {{ mail.sentCount ? mail.sentCount : "-" }}
                                                </td>
                                                <td class="enquete-table-cell" title="{{ mail.lastSentDate ? (mail.lastSentDate | formatDateFromBack) : '-' }}">
                                                    {{ mail.lastSentDate ? (mail.lastSentDate | formatDateFromBack) : "-" }}
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        }
                    </div>
                    <div class="row mt-5 mx-0">
                        @if (selectedEnquete()) {
                            <div class="col-6 d-flex justify-content-center">
                                <button (click)="onTriggerEmail()" [disabled]="working()" class="btn btn-outline-primary w-100">
                                    @if (working()) {
                                        <span class="spinner-border spinner-border-sm"></span>
                                    }
                                    @if (!working()) {
                                        <span>Déclencher un envoi de mail</span>
                                    }
                                </button>
                            </div>
                        }
                        <div class="col-6 d-flex justify-content-center">
                            <button (click)="dismissViewEnqueteModal()" [disabled]="working()" class="btn btn-outline-secondary w-100">
                                @if (working()) {
                                    <span class="spinner-border spinner-border-sm"></span>
                                }
                                @if (!working()) {
                                    <span>Fermer</span>
                                }
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card-footer mt-5">
                    <div class="row">
                        <form [formGroup]="buildMailLinkForm">
                            <div class="col-12 d-flex align-items-center">
                                <div class="m-0 text-start text-muted small">Générer lien email</div>
                                <div class="px-3 m-0 text-start text-muted small">
                                    <i class="bi bi-arrow-right-circle-fill"></i>
                                </div>
                                <div class="m-0 text-end text-muted small fst-italic">statut&nbsp;</div>
                                <div class="pe-2 btn-group">
                                    <input [value]="'VALIDE'" autocomplete="off" class="btn-check" formControlName="statutLancement" id="statut_lancement_valide" type="radio" />
                                    <label class="btn btn-outline-secondary btn-sm" for="statut_lancement_valide">Oui</label>
                                    <input [value]="'REFUSLG'" autocomplete="off" class="btn-check" formControlName="statutLancement" id="statut_lancement_invalide" type="radio" />
                                    <label class="btn btn-outline-secondary btn-sm" for="statut_lancement_invalide">Non</label>
                                </div>
                                <div class="px-3 m-0 text-start text-muted small">
                                    <i class="bi bi-plus-circle-fill"></i>
                                </div>
                                <div class="m-0 text-end text-muted small fst-italic">sav&nbsp;</div>
                                <div class="pe-2 btn-group">
                                    <input [value]="true" autocomplete="off" class="btn-check" formControlName="gestionSav" id="gestion_sav_true" type="radio" />
                                    <label class="btn btn-outline-secondary btn-sm" for="gestion_sav_true">Oui</label>
                                    <input [value]="null" autocomplete="off" class="btn-check" formControlName="gestionSav" id="gestion_sav_null" type="radio" />
                                    <label class="btn btn-outline-secondary btn-sm" for="gestion_sav_null">&nbsp;<i class="bi bi-slash-circle">&nbsp;</i></label>
                                    <input [value]="false" autocomplete="off" class="btn-check" formControlName="gestionSav" id="gestion_sav_false" type="radio" />
                                    <label class="btn btn-outline-secondary btn-sm" for="gestion_sav_false">Non</label>
                                </div>
                                <div class="px-3 m-0 text-start text-muted small">
                                    <i class="bi bi-plus-circle-fill"></i>
                                </div>
                                <div class="m-0 text-end text-muted small fst-italic">date ultérieure&nbsp;</div>
                                <div class="pe-2 btn-group">
                                    <input [value]="true" autocomplete="off" class="btn-check" formControlName="delayedLaunch" id="delayed_launch_true" type="radio" />
                                    <label class="btn btn-outline-secondary btn-sm" for="delayed_launch_true">Oui</label>
                                    <input [value]="false" autocomplete="off" class="btn-check" formControlName="delayedLaunch" id="delayed_launch_false" type="radio" />
                                    <label class="btn btn-outline-secondary btn-sm" for="delayed_launch_false">Non</label>
                                </div>
                                <div class="px-3 m-0 text-start text-muted small">
                                    <i class="bi bi-arrow-right-circle-fill"></i>
                                </div>
                                <button (click)="onBuildMailLink()" [disabled]="working()" class="btn btn-secondary btn-sm ms-2">
                                    <i class="bi bi-box-arrow-up-right"></i>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        }
    </div>
</ng-template>

<ng-template #createEmailModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Ajout d'un email</h4>
        <button (click)="dismissCreateEmailModal(modal)" [disabled]="working()" aria-label="Close" class="btn-close" type="button"></button>
    </div>
    <div class="modal-body d-flex w-100 justify-content-center align-items-center">
        <form #createEmailFormElement="ngForm" [formGroup]="createEmailForm" class="w-100">
            <div class="row flex-column mt-3">
                <div class="col-12 mb-3">
                    <label class="form-label" for="emailType">Type :</label>
                    <select [ngClass]="shouldDisplayInvalid(createEmailForm, createEmailFormElement, 'emailType') ? 'is-invalid' : ''" class="form-select" formControlName="emailType" id="emailType">
                        @for (type of getFilteredTypeUseCases(); track type) {
                            <option [title]="type.label" [value]="type.code">
                                {{ type.label }}
                            </option>
                        }
                    </select>
                    <div class="invalid-feedback">
                        @if (createEmailForm.get("emailType").errors?.["required"]) {
                            <div>Le champ Type est obligatoire</div>
                        }
                    </div>
                </div>

                <div class="col-12 mb-3">
                    <label class="form-label" for="sentCount">Nombre d'envoi :</label>
                    <input [ngClass]="shouldDisplayInvalid(createEmailForm, createEmailFormElement, 'sentCount') ? 'is-invalid' : ''" class="form-control" formControlName="sentCount" id="sentCount" min="0" type="number" />
                    <div class="invalid-feedback">
                        @if (createEmailForm.get("sentCount").errors?.["required"]) {
                            <div>Le nombre d'envoi est obligatoire</div>
                        }
                        @if (createEmailForm.get("sentCount").errors?.["min"]) {
                            <div>Le nombre d'envoi doit être supérieur ou égal à 0</div>
                        }
                    </div>
                </div>

                <div class="col-12 mb-3">
                    <label class="form-label" for="lastSentDate">Dernière date d'envoi :</label>
                    <input [ngClass]="shouldDisplayInvalid(createEmailForm, createEmailFormElement, 'lastSentDate') ? 'is-invalid' : ''" class="form-control" formControlName="lastSentDate" id="lastSentDate" type="datetime-local" />
                    <div class="invalid-feedback">
                        @if (createEmailForm.get("lastSentDate").errors?.["required"]) {
                            <div>La dernière date d'envoi est obligatoire</div>
                        }
                    </div>
                </div>

                <div class="row mt-5 mx-0">
                    <div class="col-6 d-flex justify-content-center">
                        <button (click)="onCreateEmailSubmit(modal)" [disabled]="working()" class="btn btn-outline-primary w-100" type="submit">
                            @if (working()) {
                                <span class="spinner-border spinner-border-sm"></span>
                            }
                            @if (!working()) {
                                <span>Sauvegarder</span>
                            }
                        </button>
                    </div>
                    <div class="col-6 d-flex justify-content-center">
                        <button (click)="dismissCreateEmailModal(modal)" [disabled]="working()" class="btn btn-outline-secondary w-100">
                            @if (working()) {
                                <span class="spinner-border spinner-border-sm"></span>
                            }
                            @if (!working()) {
                                <span>Annuler</span>
                            }
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #updateStatusModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Modification du Statut</h4>
        <button (click)="dismissUpdateStatusModal(modal)" [disabled]="working()" aria-label="Close" class="btn-close" type="button"></button>
    </div>
    <div class="modal-body d-flex w-100 justify-content-center align-items-center">
        <form #updateStatusFormElement="ngForm" [formGroup]="updateStatusForm" class="w-100">
            <div class="row flex-column mt-3">
                <div class="col-12 mb-3">
                    <label class="form-label" for="status">Status :</label>
                    <select [ngClass]="shouldDisplayInvalid(updateStatusForm, updateStatusFormElement, 'status') ? 'is-invalid' : ''" class="form-select" formControlName="status" id="status">
                        @for (status of typeStatus; track status) {
                            <option [title]="status" [value]="status">
                                {{ status }}
                            </option>
                        }
                    </select>
                    <div class="invalid-feedback">
                        @if (updateStatusForm.get("status").errors?.["required"]) {
                            <div>Le champ Status est obligatoire</div>
                        }
                    </div>
                </div>

                <div class="row mt-5 mx-0">
                    <div class="col-6 d-flex justify-content-center">
                        <button (click)="onEditStatusSubmit(modal)" [disabled]="working()" class="btn btn-outline-primary w-100" type="submit">
                            @if (working()) {
                                <span class="spinner-border spinner-border-sm"></span>
                            }
                            @if (!working()) {
                                <span>Sauvegarder</span>
                            }
                        </button>
                    </div>
                    <div class="col-6 d-flex justify-content-center">
                        <button (click)="dismissUpdateStatusModal(modal)" [disabled]="working()" class="btn btn-outline-secondary w-100">
                            @if (working()) {
                                <span class="spinner-border spinner-border-sm"></span>
                            }
                            @if (!working()) {
                                <span>Annuler</span>
                            }
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-template>
